import tempcheckinterval from './tempcheckinterval';
import tempreportconfig from './tempreportconfig';

export default { tempcheckinterval, tempreportconfig };
